// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95b895eb","455":"289b96fb","644":"f943d47a"}[chunkId] + ".chunk.js";
};